import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="w-full bg-cream px-5 py-16 md:py-24" data-id="element-129" data-mp="1clpk2p8rc6uk">
      <div className="mx-auto max-w-5xl" data-id="element-130" data-mp="18k4b3ezcgcpn">
        <SectionHeading eyebrow="Because I want you to start with everything you need…" title="5 exclusive bonuses — FREE with your purchase" data-id="element-131" data-mp="18lfg1i4izqic" />
        <div className="mx-auto mt-6 flex max-w-md items-center justify-center gap-4 rounded-2xl bg-brand-olive px-5 py-4 text-cream" data-id="element-132" data-mp="20btq139f4ioq">
          <GiftIcon className="h-7 w-7 shrink-0 text-[#CFC8E6]" aria-hidden="true" data-id="element-133" data-mp="1wb9rpwd3z910" />
          <p className="text-[15px] leading-snug" data-id="element-134" data-mp="1r9kcs5mrmb7n">
            Total bonus value: <span className="line-through opacity-70" data-id="element-135" data-mp="ku9ymyixsq5x">$187</span>
            <br data-id="element-136" data-mp="fux55uxk8kud" />
            <strong className="text-lg" data-id="element-137" data-mp="fudv10e5j0qw">Today: Included FREE</strong>
          </p>
        </div>

        <ol className="mt-12 space-y-10 md:space-y-16" data-id="element-138" data-mp="1et576pcydt4b">
          {bonuses.map((b, i) => <li key={b.number} className="-mx-5 overflow-hidden bg-paper md:mx-0 md:grid md:grid-cols-2 md:items-center md:gap-10 md:rounded-3xl md:p-8" data-id="element-139" data-mp="1jshrp3gcqo3q" data-mpi={i}>
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className={`w-full ${i % 2 === 1 ? "md:order-2" : ""} md:rounded-2xl`} data-id="element-140" data-mp="1artda7n1qlqb" />
              <div className="px-5 pb-8 pt-6 md:p-0" data-id="element-141" data-mp="10uf9b7ib7pew">
                <div className="flex flex-wrap items-center gap-3" data-id="element-142" data-mp="10v6v5qm3u8rz">
                  <span className="rounded-full bg-brand-lavender px-3 py-1 text-[12px] font-bold uppercase tracking-widest text-white" data-id="element-143" data-mp="n3iinm7y1iah">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm text-ink/60" data-id="element-144" data-mp="d5clfhx310by">
                    Value: <span className="line-through" data-id="element-145" data-mp="i34jyus8fkp4">${b.value}</span>{" "}
                    <strong className="text-brand-cta" data-id="element-146" data-mp="i5h3vdhjw54t">FREE today</strong>
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-[28px] font-bold leading-tight text-ink md:text-4xl" data-id="element-147" data-mp="2f1v2cxekqagm">{b.title}</h3>
                <div className="mt-4 space-y-3 text-[17px] leading-relaxed text-ink/85" data-id="element-148" data-mp="2azqb25bllpx5">
                  {b.paragraphs.map(p => <p key={p} data-id="element-149" data-mp="262q8i4dyj5as">{p}</p>)}
                </div>

                {b.listType === "chips" && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-150" data-mp="32p38tinqnpk8">
                    {b.list.map(item => <li key={item} className="rounded-full bg-brand-mist px-3 py-1.5 text-sm font-semibold text-brand-olive" data-id="element-151" data-mp="2tqrb6wogfria">
                        {item}
                      </li>)}
                  </ul>}

                {b.listType === "checks" && <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-152" data-mp="1dchm20ce1yqe">
                    {b.list.map(item => <li key={item} className="flex gap-2 text-[16px] text-ink/90" data-id="element-153" data-mp="1392tc9t78uko">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-cta" aria-hidden="true" data-id="element-154" data-mp="187e54q321f5j" />
                        {item}
                      </li>)}
                  </ul>}

                {b.listType === "days" && <ol className="mt-5 space-y-2 border-l-2 border-brand-sage/50 pl-5" data-id="element-155" data-mp="1hzjwpype9uk7">
                    {b.list.map((item, d) => <li key={item} className="relative text-[16px] text-ink/90" data-id="element-156" data-mp="1qxm2erk2pbdt" data-mpi={d}>
                        <span className="absolute -left-[27px] top-1.5 h-3 w-3 rounded-full bg-brand-sage" aria-hidden="true" data-id="element-157" data-mp="1vx8egxo60ll1" />
                        <strong className="text-brand-olive" data-id="element-158" data-mp="20wkzrdze1kli">Day {d + 1}</strong> — {item}
                      </li>)}
                  </ol>}

                {b.closing && <p className="mt-5 font-serif text-lg font-semibold italic leading-snug text-brand-olive" data-id="element-159" data-mp="6j3c7qyzgnqh">{b.closing}</p>}
              </div>
            </li>)}
        </ol>

        <div className="mt-12" data-id="element-160" data-mp="1rzj6x4izlrdf">
          <CtaButton label="I Want All 5 Bonuses Free" data-id="element-161" data-mp="1s2f58tyqyi2e" />
        </div>
      </div>
    </section>;
}